<template>
  <div class="item profile" v-if="user">
    <ProfileAvatarComponent
      class="small"
      :badges="false"
      :border="true"
      :profileImage="getUserProfilePicture(user)"
    />
    <p>
      {{ user.fullName }}
      <span class="autoSpan">{{ user.userName }}</span>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ProfileAvatarComponent from "@/components/ProfileAvatarComponent.vue";
import GeneralUserModel from "../../models/generaluser.model";
import utilService from "@/services/util.service";

export default defineComponent({
  props: {
    user: GeneralUserModel,
  },
  components: {
    ProfileAvatarComponent,
  },
  setup() {
    const getUserProfilePicture = (user: GeneralUserModel) =>
      utilService.getUserProfilePicture(
        user._id!,
        user.profilePicture!,
        user.gender!
      );

    return {
      getUserProfilePicture,
    };
  },
});
</script>
